module.exports = __webpack_public_path__ + "media/images/12-f9cd10e6.svg";